export default class Driver {

    constructor(data) {
        this.id = null;
        this.title = null;
        this.name = null;
        this.phone = null;
        this.mobile = null;
        this.fax = null;
        this.email = null;
        this.street = null;
        this.zipcode = null;
        this.city = null;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/driver.model.js